import React from "react";
import styles from "./trainingprogramdeailsmodal.module.scss";
import { FaStar } from "react-icons/fa";
import { IoCall, IoCheckmarkDone } from "react-icons/io5";
import { RxCross2 } from "react-icons/rx";
import { useDispatch, useSelector } from "react-redux";
import { useEnrollPartnerTraining } from "../../hooks/partnerHook/usePartnerTraining";
import { useEffect } from "react";
import { updateUser } from "../../store/Partner/partnerDataSlice";

function TrainingProgramDetailsModal({ setShowDetails, setFullprogramDetails, fullProgramDetails }) {
    const userData = useSelector((state) => state.partner.user)
    console.log("userData______", userData);

    const handleModalClosure = () => {
        setShowDetails(false);
        setFullprogramDetails(null)
    }
    const { mutate: enrollToTrainingProgram, isSuccess, isError, isPending } = useEnrollPartnerTraining();
    const enrollToProgram = async () => {
        console.log('Enrolling to training!', userData.partner.id, fullProgramDetails.program_id);
        enrollToTrainingProgram({ partnerId: userData.partner.id, programId: fullProgramDetails.program_id })
    }
    const dispatch = useDispatch()
    useEffect(() => {
        if (isSuccess) {
            // Create a new training array with the new data
            const updatedTrainings = [...userData.partner.trainings, fullProgramDetails];

            const newData = {
                ...userData,
                partner: {
                    ...userData.partner,
                    trainings: updatedTrainings,
                },
            };

            dispatch(updateUser(newData));
        }
    }, [isSuccess]);

    return (
        <div className="container-background content-center">
            <div className={styles.programDetailsContainer}>
                <div className={styles.closeBtn} onClick={handleModalClosure}  >
                    <RxCross2 />
                </div>
                <div className={styles.programMedia}>
                    <img
                        src="https://img.freepik.com/free-photo/stock-aerial-video-creator-photographer-prepares-drone-flight_346278-260.jpg"
                        alt=""
                    />
                </div>

                <div className={styles.programContent}>
                    <h3 className={styles.programHeading}>Drone Pilot Licence Course</h3>

                    <div className={styles.ratingContainer}>
                        <FaStar /> 4.7 | 405 Reviews
                    </div>

                    <div className={styles.publishDetails}>
                        <div className={styles.publishdate}>
                            <h4>Published</h4>
                            <p>10th Oct 2024</p>
                        </div>

                        <div className={styles.enrollDate}>
                            <h4>Enrolled Users</h4>
                            <p>1678 Ratings</p>
                        </div>
                    </div>

                    <div className={styles.requestCallback}>
                        <p>Request a Callback from our team.</p>
                        <button> <IoCall />  Request a callback.</button>
                    </div>

                    <section className={styles.programSection}>
                        <h4 className={styles.sectionHeading}>Description</h4>
                        <div className={styles.sectionBody}>
                            <p>
                                Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                                Reiciendis dolorum consectetur quibusdam facere illo sequi
                                voluptatum, enim quod veniam ea? Ipsa perspiciatis error laborum!
                                Similique architecto nesciunt at perspiciatis maiores, sunt
                                officiis. Perferendis, iusto alias quas officiis repudiandae odit
                                possimus expedita quisquam repellendus reprehenderit consequatur.
                            </p>
                        </div>
                    </section>

                    <section className={styles.programSection}>
                        <h4 className={styles.sectionHeading}>Eligiblity</h4>
                        <div className={styles.sectionBody}>
                            <ul className={styles.eligiblityCriteria}>
                                <li>
                                    <h5>Minimum Age</h5>
                                    <p>18 Years</p>
                                </li>
                                <li>
                                    <h5>Education Criteria</h5>
                                    <p>Matriculation</p>
                                </li>
                                <li>
                                    <h5>Required Documents</h5>
                                    <p>Adhaar Card & Pan Card.</p>
                                </li>
                            </ul>
                        </div>
                    </section>
                </div>

                <div className={styles.programBtnContainer}>
                    <div className={styles.priceTag}>
                        <span className={styles.startsWith}>Starts at</span>
                        <span className={styles.price}>₹ 25,000</span>
                    </div>
                    {
                        userData.partner.trainings.some(training => training.program_id === fullProgramDetails.program_id) ?
                            <button className={styles.enrolledBtn}>
                                <IoCheckmarkDone /> Already Enrolled
                            </button>
                            :
                            <button onClick={enrollToProgram} className={styles.enrollBtn}>Enroll</button>
                    }

                </div>
            </div>
        </div>
    );
}

export default TrainingProgramDetailsModal;
